import introJs from "intro.js";

import Interfaces from "./_interfaces";
import Modal from "./_bootstrapModalExtensions";

import { InitAutocompletes } from "./_autocomplete";
import { InitSettlementInputRow } from "./_address";

import * as Intro from "./Intros/_IntroBase";
import { getDomElementByConfig, getConfigValue } from "./Utils/DataTagConfigurationUtil";
import { updateProgressBar } from "./components/progressBar";
import { ProcessTypeConfigModel, GetDefaultConfig, GetConfigForValue } from "./models/processTypeConfigModel";
import { updateShortDescriptionRequiredField } from "./components/fields/shortDescription";
import { updateNMTKFieldVisibility } from "./components/fields/nmtk";
import { updateProcessTypeChangedAlert } from "./components/processTypeChangedAlert";
import { setIsConstructionActivityMandatory } from "./components/fields/constructionActivity";
import { updateSimpleProcessFields } from "./components/simpleProcess";

let displayPersonalDataDiv: JQuery<HTMLElement>;
let editorPersonalDataDiv: JQuery<HTMLElement>;
let $applicantType: JQuery<HTMLElement>;
let $applicantTypeDropDownDiv: JQuery<HTMLElement>;
let $isCorporationRow: JQuery<HTMLElement>;
let $isCorporationRowContent: JQuery<HTMLElement>;

function onProcessTypeChanged(newValue: string, originalValue: string) {

    let currentConfig = GetConfigForValue(newValue) || GetDefaultConfig();

    updateShortDescriptionRequiredField(currentConfig);
    updateNMTKFieldVisibility(currentConfig);
    updateSimpleProcessFields(currentConfig);
    setIsConstructionActivityMandatory(currentConfig);
    updateProcessTypeChangedAlert(newValue, originalValue);
    updateProgressBar(newValue);
}

function onIsNgszChanged(element: HTMLInputElement) {
    let ngszTextDomElement = getDomElementByConfig<HTMLInputElement>('ngsz-description-id');

    if (element.checked) {
        ngszTextDomElement.classList.add("required_field");
    }
    else {
        ngszTextDomElement.classList.remove("required_field");
    }
}

function InitProcessCreateWizard(mainProcessTypeDomElement: HTMLSelectElement) {

    let $form: JQuery<HTMLFormElement> = $("#process-create-with-wizard");

    if (!$form) {
        return;
    }

    // Disable the normal submit, as there is work to do before any submitting can be done
    // (namely, displaying popups and setting up hidden variables)
    $form.submit((e) => {
        e.preventDefault();
    });

    // When the save-and-skip button is pressed, the user wants to leave the wizard
    // set the skipWizard to true and additionalApplicantRequired to false
    // then use the default submit method
    $('#submit-skipWizard').click((e) => {
        e.preventDefault();

        if ($form.valid()) {
            submit_internal(true, false);
        }
    });

    // Continue with the wizard
    // If the processStartType is 'You are the applicant', then display the popup dialog (so he can add additional Applicants beside himself) (The dialog will submit the form)
    // Otherwise, just continue with the wizard
    $('#submit-continue').click((e) => {
        e.preventDefault();

        let processStartTypeDomElement = getDomElementByConfig<HTMLSelectElement>('process-start-type-field-id');
        let processStartType: string = processStartTypeDomElement.value as string;
        let sajatNevebenEnum: string = window.ETDR_RD.appConfig['Constants.ProcessStartTypeSajatNeveben']

        if ($form.valid()) {
            if (processStartType === sajatNevebenEnum) {

                // Show the "add additional applicants?" confirmation dialog
                // This will also submit the form and will not call validation
                Modal.showConfirmationWindowAsync(
                    'Ön lesz az eljárás kiemelt ügyfele!<br />Kíván további kérelmezőket rögzíteni?',
                    'További kérelmező rögzítése',
                    () => {
                        submit_internal(false, false);
                    },
                    () => {
                        submit_internal(false, true);
                    },
                    'Nem',
                    'Igen');
            }
            else {
                submit_internal(false, false);
            }
        }
    });

    function submit_internal(skipWizard, additionalApplicantRequired) {

        let currentConfig = GetConfigForValue(mainProcessTypeDomElement.value);

        // Append the scdm struct as a hidden field (it is JSON text, related to the 300nm processes)
        if (currentConfig.IsSimpleProcess) {
            let $scdmInput = $('<input type="hidden" name="scdm" />');
            $scdmInput.val(GetSCDM());
            $form.append($scdmInput);

            // This is already submitted in the hidden field
            $("#simple-process-details").remove();
        }

        // Set the internal hidden fields based on the parameters
        $form.append($('<input type="hidden" name="skipWizard" value="' + skipWizard + '"/>'));
        $form.append($('<input type="hidden" name="additionalApplicantRequired" value="' + additionalApplicantRequired + '"/>'));

        // Then use the native submit
        $form.get(0).submit();
    }
}

function GetSCDM() {

    let $buildings: JQuery<HTMLElement> = $("#building-list > .building-detail");

    let result: any = {
        Buildings: [],
        IsPublicFundUsed: $('input[name="IsPublicFundUsed"]:checked').val(),
        ConstructionForOwnUse: $('input[name="ConstructionForOwnUse"]:checked').val()
    };

    $buildings.each((ind, elem) => {
        result.Buildings.push(getBuildingFor(elem));
    });

    return JSON.stringify(result);

    function getBuildingFor(elem) {
        let $elem: JQuery<HTMLElement> = $(elem);

        let building: any = {
            CalculatedValue: $elem.find("input.calculated-value").val(),
            ContainsOtherFunctions: $elem.find("input.contains-other-function:checked").val(),
            UniqueId: $elem.find("input.uniqueId-building").val(),
            Apartments: getFlatsFor($elem),
            NatureOfConstruction: $elem.find("select.nature-of-process").val()
        };

        return building;
    }

    function getFlatsFor($buildingElem) {
        let $flatsDom: JQuery<HTMLElement> = $buildingElem.find(".flat-list .flat-details");

        let flats: Array<HTMLElement> = [];

        $flatsDom.each((ind, elem) => {
            flats.push(getFlat(elem));
        });

        return flats;
    }

    function getFlat(elem) {
        let $elem: JQuery<HTMLElement> = $(elem);

        let flat: any = {
            UsefulFloorArea: $elem.find("input.useful-floor-area").val(),
            UniqueId: $elem.find("input.uniqueId-flat").val(),
        };

        return flat;
    }
}

export function CheckIfTheActingOfficeHasTheMainProcessTypesScope(errorDivId: string, processId: number) {

    if (processId === null || processId === undefined) {
        return;
    }

    $.ajax({
        url: window.ETDR_RD.appConfig["UrlAction.CheckIfTheActingOfficeHasTheMainProcessTypesScope"],
        method: "POST",
        data: { processId: processId },
        success: function (data, textStatus, jqXHR) {
            // Http 200 response
            // Communication OK, the request has been fulfilled or couldn't, due to handled exception
            if (data.success) {
                if (data.result) {
                    // If the office has the scope corresponding to the main process type, hide the alert
                    $(errorDivId).hide();
                } else {
                    // If the office hasn't got the scope corresponding to the main process type, show an alert
                    $(errorDivId).show();
                }
            }
        }
    });
}

export function OnUniqueIdChange(
    $uniqueIdInput: JQuery<HTMLElement>,
    $partnerDataContainer: JQuery<HTMLElement>,
    $submitButtonDiv: JQuery<HTMLElement>,
    userIdElementId: string,
    callbackUrl: string,
    basicOptions: HTMLElement,
    extendedOptions: HTMLElement,
    $contactTypeDropdown: JQuery<HTMLElement>,
    applicantTypeInputId: string,
    isCorporationInputId: string) {

    displayPersonalDataDiv = $("#displayPersonalDataDiv");
    editorPersonalDataDiv = $("#editorPersonalDataDiv");
    $applicantType = $('#applicant-type-input-field');
    $applicantTypeDropDownDiv = $applicantType.children();
    $isCorporationRow = $('#is-corporation-row');
    $isCorporationRowContent = $isCorporationRow.children();

    reSetUserDataDiv();

    $uniqueIdInput.on('change', () => {
        displayPersonalDataDiv.detach();
        editorPersonalDataDiv.detach();
        reSetUserDataDiv();
        IsGuidValid();
    });

    if ($uniqueIdInput.val() !== "") {
        IsGuidValid();
    }

    function IsGuidValid() {
        let val: string = $uniqueIdInput.val().toString();

        // Heuristic for the length. A valid unique Id must consist of exactly 16 or 18 characters.
        if (val.length === 18 || val.length === 16) {
            LoadPartnerData(val);
        }
    }

    function reSetUserDataDiv() {
        $("#personalDataInnerDiv").children().detach();

        if ($uniqueIdInput.val()) {
            $partnerDataContainer.append(displayPersonalDataDiv);
            $(document).trigger('DatePickerInit');
            displayPersonalDataDiv.removeAttr('style');
            $applicantType.children().detach();
            $applicantType.append(getApplicantTypeInputTemplate);
            $isCorporationRow.children().detach();
            $isCorporationRow.append(getIsCorporationInputTemplate);
        } else {
            $partnerDataContainer.append(editorPersonalDataDiv);
            $(document).trigger('DatePickerInit');
            $applicantType.children().detach();
            $applicantType.append($applicantTypeDropDownDiv);
            $isCorporationRow.children().detach();
            $isCorporationRow.append($isCorporationRowContent);
        }
    }

    function getApplicantTypeInputTemplate(): string {
        return `<div class="px-3">
                        <span>
                            Természetes személy
                        </span><input id="` + applicantTypeInputId + `" name="` + applicantTypeInputId + `" type="hidden" value="NaturalPerson">
                    </div>`;
    }

    function getIsCorporationInputTemplate(): string {
        return '<input name="' + isCorporationInputId + '" type="hidden" value="false">';
    }

    function LoadPartnerData(uniqueId: string) {

        $submitButtonDiv.prop("disabled", true);
        $partnerDataContainer.prop("disabled", true);

        $partnerDataContainer.load(callbackUrl, { UniqueId: uniqueId }, function (response, status, xhr) {
            if (status === "success") {
                var userId = $(xhr.responseText).find('#' + userIdElementId).val();

                if (userId !== "" && userId !== undefined) {
                    // If the user id field is not zero (a match found for the unique Id), show the extra option (the in-system contact types)
                    UpdateContactTypeDropdown(true);
                    InitAutocompletes();
                    InitSettlementInputRow();
                }
                else {
                    UpdateContactTypeDropdown(false);
                }
            }
        });

        // Since the content is replaced, no need to remove the disabled props from the form (only from the buttons)
        $submitButtonDiv.prop("disabled", false);
    }

    function UpdateContactTypeDropdown(showAllOptions: boolean) {

        let newOptions = basicOptions;

        if (showAllOptions) {
            newOptions = extendedOptions;
        }

        var selectedOption = $contactTypeDropdown.find(':selected').attr('value');
        $contactTypeDropdown.empty();
        $contactTypeDropdown.append($("<option></option>").attr("value", "").text(""));
        $.each(newOptions, function (key, value) {
            $contactTypeDropdown.append($("<option></option>").attr("value", value.toString()).text(key.toString()));
        });
        $contactTypeDropdown.find("option[value='" + selectedOption + "']").prop('selected', true);
    }
}

export function CompleteSubmissionIntroAutoStart() {
    if (!window.SettingsManager.getAttribute('completeSubmissionIntro')) {
        StartCompleteSubmissionIntro();
    }
}

export function StartCompleteSubmissionIntro() {

    let $infoButton: JQuery = $('#btnGroupDrop6');

    addRelatedProcessInitSteps();

    introJs()
        .setOption('exitOnOverlayClick', 'false')
        .setOption('prevLabel', 'Előző')
        .setOption('nextLabel', 'Következő')
        .setOption('skipLabel', 'x')
        .setOption('doneLabel', 'x')
        .setOption('showBullets', false)
        .onexit(() => { window.SettingsManager.setAttribute('completeSubmissionIntro', true); })
        .start();

    setTimeout(() => $infoButton.click(), 1000);

    function addRelatedProcessInitSteps() {
        Intro.initSingleStepTemplateHeader($infoButton, 1, 'Hiánytalan bejelentés', 'A "Hiánytalan bejelentés" gomb megnyomásával az egyszerű bejelentés jogutódlás eljárása Befejezve állapotra áll, és kikerül a folyamatban lévő eljárások közül.');
    }
}

export function ProcessSignOffChange(processId: number) {
    let submitFunc: Function = () => {
        if (!processId) {
            return;
        }

        let $saveButton: JQuery = $('#form-modal-save');
        $saveButton.prop('disabled', true);

        let $errorWrapper: JQuery = $('#form-modal-error');

        let grid: MVCxClientGridView = window['ListClerksByOffice_For_SignOff'] as MVCxClientGridView;
        let focusedRowRowIndex: number = grid.GetFocusedRowIndex();
        let selectedRowKey: string = grid.GetRowKey(focusedRowRowIndex);
        let selectedClerkId: string = selectedRowKey.split('|')[0];

        $.ajax({
            method: 'POST',
            url: window.ETDR_RD.appConfig['UrlAction.ProcessSignOff'],
            data: {
                processId: processId,
                selectedClerkId: selectedClerkId
            },
            headers: { Accept: 'application/json' }
        })
            .done((data) => {
                if (data.success) {
                    AfterProcessSignOff(data.selectedClerkName, data.filingState);
                    $('#generic-modal-form').modal('hide');
                } else {
                    $errorWrapper.text(data.message).show();
                }
            })
            .fail((jqXHR: JQueryXHR) => {
                // Client <-> Server communication error. The frontend server threw an exception (e.g. 404, internal server error, etc)
                let response: Interfaces.EphatFilterResponse = JSON.parse(jqXHR.responseText)

                $errorWrapper.html(response.message);
                $errorWrapper.show();
            })
            .always(() => {
                $saveButton.prop('disabled', false);
            });
    };

    let rejectFunc: Function = () => { };

    Modal.ShowBootstrapModalWithCustomContent(
        'Válasszon ügyintézőt',
        window.ETDR_RD.appConfig['UrlAction.ListClerksByOfficePartialForProcess'],
        { entityId: processId },
        submitFunc,
        rejectFunc);
}

function AfterProcessSignOff(clerkName: string, filingState: string) {
    $('#signed-clerk-display-name-cell').text(clerkName);

    if (filingState) {
        $('#fado-state-cell').text(filingState);
    }
}

jQuery(() => {
    $(document).on('click', '#sign-off-button-for-process', (event: JQuery.ClickEvent) => {
        let $btn = $(event.target) as JQuery<HTMLButtonElement>;
        ProcessSignOffChange($btn.data('process-id'));
    });

    if ($('.intro-button-container #complete-submission-intro').length) {
        Intro.AutoRunIntro(() => CompleteSubmissionIntroAutoStart(), 'completeSubmissionIntro');
    }

    let config = getConfigValue('all-process-types') as ProcessTypeConfigModel[];
    if (config) {
        // ProcessType
        let processTypeSelectorDomElement = getDomElementByConfig<HTMLSelectElement>('process-type-field-id');

        if (processTypeSelectorDomElement) {
            processTypeSelectorDomElement.addEventListener('change', (event: Event) => {
                let element = event.currentTarget as HTMLSelectElement;
                onProcessTypeChanged(element.value, element.dataset.originalValue)
            });
            onProcessTypeChanged(processTypeSelectorDomElement.value, processTypeSelectorDomElement.dataset.originalValue);

            let currentConfig = GetConfigForValue(processTypeSelectorDomElement.value) || GetDefaultConfig();
            updateSimpleProcessFields(currentConfig);

            InitProcessCreateWizard(processTypeSelectorDomElement);
        }

        // NGSZ
        let processIsNgszDomElement = getDomElementByConfig<HTMLInputElement>('process-is-ngsz-id');
        if (processIsNgszDomElement) {
            processIsNgszDomElement.addEventListener('change', (event: Event) => onIsNgszChanged(event.currentTarget as HTMLInputElement));
            onIsNgszChanged(processIsNgszDomElement);
        }
    }

    $(document).on('click', '#submission-btn', (event: JQuery.ClickEvent) => {
        let $btn = $(event.target) as JQuery<HTMLButtonElement>;
        $btn.attr('disabled', 'disabled');

        location.href = $btn.data('href');
    });
});
